"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnimationMap = void 0;
const back_in_down_1 = require("./back-in-down");
const bounce_in_1 = require("./bounce-in");
const fade_in_1 = require("./fade-in");
const light_speed_in_1 = require("./light-speed-in");
const magic_block_1 = require("./magic-block");
const moving_neon_1 = require("./moving-neon");
const neon_1 = require("./neon");
const pan_1 = require("./pan");
const rise_1 = require("./rise");
const rotate_in_a_1 = require("./rotate-in-a");
const rotate_in_b_1 = require("./rotate-in-b");
const scrapbook_a_1 = require("./scrapbook-a");
const scrapbook_b_1 = require("./scrapbook-b");
const stomp_1 = require("./stomp");
const swing_in_1 = require("./swing-in");
const tilt_in_1 = require("./tilt-in");
const zoom_in_1 = require("./zoom-in");
const zoom_out_1 = require("./zoom-out");
exports.AnimationMap = {
    no_animation: undefined,
    fade_in: fade_in_1.fadeIn,
    bounce_in: bounce_in_1.bounceIn,
    back_in_down: back_in_down_1.backInDown,
    light_speed_in: light_speed_in_1.lightSpeedIn,
    magic_block: magic_block_1.magicBlock,
    moving_neon: moving_neon_1.movingNeon,
    neon: neon_1.neon,
    pan: pan_1.pan,
    rise: rise_1.rise,
    rotate_in_a: rotate_in_a_1.rotateInA,
    rotate_in_b: rotate_in_b_1.rotateInB,
    scrapbook_a: scrapbook_a_1.scrapbookA,
    scrapbook_b: scrapbook_b_1.scrapbookB,
    stomp: stomp_1.stomp,
    swing_in: swing_in_1.swingIn,
    tilt_in: tilt_in_1.tiltIn,
    zoom_in: zoom_in_1.zoomIn,
    zoom_out: zoom_out_1.zoomOut,
};
//# sourceMappingURL=index.js.map